// @flow strict
// eslint-disable-next-line import/prefer-default-export
export const toRender = (rating: number, stars: number) => ({
  full: Math.floor(rating) + (rating % 1 >= 0.75 ? 1 : 0),
  half: (stars - rating) % 1 > 0.25 && (stars - rating) % 1 <= 0.75 && (stars - rating) % 1 !== 0,
  empty: (stars - rating) % 1 <= 0.75 ? Math.floor(stars - rating) : Math.ceil(stars - rating),
});
